// @flow
import { type Node } from 'react';

import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getMoneyFormat } from '@tectonics/look-and-feel/volcanes/commons/money-format';
import { getInstalmentsPlan } from '@tectonics/prs/receipts/receipt';

export function InstalmentPlanText(): Node {
  const receipt = useCurrentReceipt();

  const formatAmount = amountToCurrencyString(getMoneyFormat('br'));
  const instalmentsPlan = getInstalmentsPlan(receipt);

  if (!instalmentsPlan)
    return null;

  return `${instalmentsPlan.instalments}x de ${formatAmount(instalmentsPlan.amount_partial_first)}`;
}
